import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectsGrid = ({ projects, onProjectClick, onStatusUpdate }) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'validado':
        return 'bg-success/10 text-success border-success/20';
      case 'en verificación':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'en desarrollo':
        return 'bg-accent/10 text-accent border-accent/20';
      case 'pendiente':
        return 'bg-muted text-muted-foreground border-border';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getProjectTypeIcon = (type) => {
    const typeMap = {
      'A/R': 'TreePine',
      'IFM': 'Trees',
      'REDD+': 'Shield',
      'SOC': 'Sprout',
      'Ganadería Regenerativa': 'Beef'
    };
    return typeMap?.[type] || 'FolderTree';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {projects?.map((project) => (
        <div
          key={project?.id}
          className="card cursor-pointer"
          onClick={() => onProjectClick(project)}
        >
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center gap-3">
              <div
                className="flex items-center justify-center w-12 h-12 rounded-lg flex-shrink-0"
                style={{ backgroundColor: 'var(--color-primary)15' }}
              >
                <Icon
                  name={getProjectTypeIcon(project?.projectType)}
                  size={20}
                  color="var(--color-primary)"
                />
              </div>
              <div className="min-w-0">
                <h3 className="font-semibold text-base text-foreground truncate">
                  {project?.name}
                </h3>
                <p className="text-xs text-muted-foreground caption">ID: {project?.id}</p>
              </div>
            </div>
            <input
              type="checkbox"
              onClick={(e) => e?.stopPropagation()}
              className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-primary focus:ring-offset-2"
              aria-label={`Seleccionar ${project?.name}`}
            />
          </div>

          <div className="space-y-3 mb-4">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground caption">País</span>
              <span className="text-sm font-medium text-foreground">{project?.country}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground caption">Tipo</span>
              <span className="text-sm font-medium text-foreground">{project?.projectType}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground caption">Estándar</span>
              <span className="text-sm font-medium text-foreground">{project?.standard}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground caption">Estado</span>
              <span
                className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium border ${getStatusColor(
                  project?.status
                )}`}
              >
                {project?.status}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-4 p-3 bg-muted/30 rounded-lg">
            <div>
              <div className="text-xs text-muted-foreground caption mb-1">tCO₂e/año</div>
              <div className="text-lg font-semibold data-text text-foreground">
                {project?.tco2ePerYear?.toLocaleString('es-ES')}
              </div>
            </div>
            <div>
              <div className="text-xs text-muted-foreground caption mb-1">ER/ha</div>
              <div className="text-lg font-semibold data-text text-foreground">
                {project?.erPerHa?.toFixed(2)}
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2" onClick={(e) => e?.stopPropagation()}>
            <Button
              variant="outline"
              size="sm"
              fullWidth
              onClick={() => navigate(`/project-detail-view?id=${project?.id}`)}
              iconName="Eye"
              iconPosition="left"
            >
              Ver Detalles
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onStatusUpdate(project)}
              iconName="Edit"
              iconSize={16}
              title="Editar estado"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectsGrid;